import React from "react";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <ContactForm />
    </section>
  );
};

export default Contact;
